import React from 'react';
import {
  Link
} from 'react-router-dom'
import './App.css';

const GameInfo = ({gameCost, maxTiles}) => (
    <div className="game-info">
        <h2> Calling All Heroes </h2>
        <ul>
            <li> Hash Heroes is a daring game powered by Ethereum. </li>
            <li> Anyone in the world can seek their destiny in the arena below. Just click on a tile to claim it. The number of tiles you can claim is limited only by your will.</li>
            <li> Once all the tiles are claimed, a winner is determined on the Ethereum blockchain. They are rewarded with eternal glory on the winners page. A new game begins immediately afterwards.</li>
            <li> The heroes' arena can be viewed on mobile devices, but only those on computers using the MetaMask extension can play. </li>
        </ul>
        <div className="read-more"> <Link to="/about">Read more...</Link></div>
    </div>
);

export default GameInfo;



// WEBPACK FOOTER //
// ./src/components/GameInfo.js